import React from "react";

interface CalloutSectionProps {
  quote: React.ReactNode;
  cite: React.ReactNode;
}

const CalloutSection: React.FC<CalloutSectionProps> = ({ quote, cite }) => {
  return (
    <section className="cs-section cs-callout">
      <div className="cs-callout-inner">
        <div className="cs-callout-mark">&ldquo;</div>
        <blockquote>{quote}</blockquote>
        <cite>{cite}</cite>
      </div>
    </section>
  );
};

export default CalloutSection;
